import { SsDomaineModel } from '../simple-types/ss-domaine.model';
import { SsFamilleModel } from '../simple-types/ss-famille.model';
import { SocieteLinkedModel } from './societe-linked.model';

export class ArticleModel extends SocieteLinkedModel {
    codeSite: string;
    libelleSite: string;
    // prix unitaire obligatoire et min 0
    pu: number;
    // max length 40
    unité: string;

    commun: boolean;
    modifie: boolean;

    idNa: number;
    idSite: number;
    idCgCharge: number;
    idFamille: number;
    idDomaine: number;
    idTva: number;

    codeNa: string;
    libelleNa :string;
    codeCg: string;
    libelleCg: string
    codeTva: string;
    libelleTva: string;
    // length 15 / obligatoire
    codeCategorie: string;
    libelleCategorie: string;
    idSsDomaine: number;
    ssDomaine: SsDomaineModel;
    idSsFamille: number;
    ssFamille: SsFamilleModel;
}
